import { Module } from 'vuex'
import getters from '@/store/revision/getters'
import actions from '@/store/revision/actions'
import mutations from '@/store/revision/mutations'
import { RootState } from '@/store/types'
import { RevisionState } from './types'

const state: RevisionState = {
    revisions: [],
    tracking: '',
    viewing: null
}

const revision: Module<RevisionState, RootState> = {
    state,
    getters,
    actions,
    mutations
}

export default revision
